/**
 * 钉钉 JSAPI 工具模块
 *
 * 使用方式：
 *   import { isInDingTalk, getAuthCode, setTitle } from '@/utils/dingtalk'
 *
 * 注意：需要先安装 dingtalk-jsapi: npm install dingtalk-jsapi --save
 */

import * as dd from 'dingtalk-jsapi'
import { logDingTalk, logError } from './serverLog'

/**
 * 检测当前环境是否在钉钉客户端内
 * 同时检测 UA 和 dingtalk-jsapi 的环境变量
 * @returns {boolean}
 */
export function isInDingTalk () {
  try {
    const ua = (navigator.userAgent || '').toLowerCase()
    const isDingTalkUA = ua.indexOf('dingtalk') > -1
    let isDingTalkEnv = false
    try {
      isDingTalkEnv = dd.env && dd.env.platform !== 'notInDingTalk'
    } catch (e) {
      isDingTalkEnv = false
    }
    const result = isDingTalkUA || isDingTalkEnv
    logDingTalk('isInDingTalk检测', { isDingTalkUA, isDingTalkEnv, result, ua: ua.substring(0, 100) })
    return result
  } catch (e) {
    logError('isInDingTalk异常', { error: e.message })
    return false
  }
}

/**
 * 获取钉钉免登临时授权码
 * @param {string} corpId 钉钉企业 CorpId
 * @returns {Promise<string>} 返回临时授权码 code
 */
export function getAuthCode (corpId) {
  return new Promise((resolve, reject) => {
    logDingTalk('开始获取授权码', { corpId })

    dd.ready(() => {
      logDingTalk('dd.ready触发', { corpId })
      dd.runtime.permission.requestAuthCode({
        corpId: corpId,
        onSuccess: (info) => {
          logDingTalk('获取授权码成功', { corpId, codePrefix: info.code ? info.code.substring(0, 8) + '...' : 'empty' })
          resolve(info.code)
        },
        onFail: (err) => {
          logError('requestAuthCode失败', { corpId, error: err.errorMessage || err.message || JSON.stringify(err) })
          reject(new Error(err.errorMessage || err.message || '获取钉钉授权码失败'))
        }
      })
    })

    dd.error((err) => {
      logError('dd.error触发', { corpId, error: err.errorMessage || err.message || JSON.stringify(err) })
      reject(new Error(err.errorMessage || err.message || '钉钉 JSAPI 初始化失败'))
    })
  })
}

/**
 * 设置钉钉导航栏标题
 * @param {string} title 标题文本
 */
export function setTitle (title) {
  dd.ready(() => {
    dd.biz.navigation.setTitle({
      title: title,
      onSuccess: () => {},
      onFail: () => {}
    })
  })
}

/**
 * 关闭钉钉 WebView 页面
 */
export function closePage () {
  dd.ready(() => {
    dd.biz.navigation.close({
      onSuccess: () => {},
      onFail: () => {}
    })
  })
}

export default {
  isInDingTalk,
  getAuthCode,
  setTitle,
  closePage
}


// WEBPACK FOOTER //
// ./src/utils/dingtalk.js